export function generateId(): string {
  return `prop_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

export function validateSchema(schema: unknown): {
  valid: boolean;
  errors: string[];
} {
  const errors: string[] = [];

  // Basic validation
  if (!schema || typeof schema !== "object" || schema === null) {
    errors.push("Schema must be an object");
    return { valid: false, errors };
  }

  const schemaObj = schema as Record<string, unknown>;

  if (!schemaObj.type) {
    errors.push("Schema must have a type");
  }

  // Validate properties if present
  if (schemaObj.properties) {
    if (
      typeof schemaObj.properties !== "object" ||
      schemaObj.properties === null
    ) {
      errors.push("Properties must be an object");
    } else {
      const propertiesObj = schemaObj.properties as Record<string, unknown>;
      Object.entries(propertiesObj).forEach(([name, prop]) => {
        if (typeof prop !== "object" || prop === null) {
          errors.push(`Property "${name}" must be an object`);
          return;
        }

        const propObj = prop as Record<string, unknown>;

        if (!propObj.type) {
          errors.push(`Property "${name}" must have a type`);
        }

        // Validate nested properties
        if (propObj.type === "object" && propObj.properties) {
          const nestedValidation = validateSchema(propObj);
          if (!nestedValidation.valid) {
            errors.push(
              `Property "${name}" has invalid nested properties: ${nestedValidation.errors.join(
                ", "
              )}`
            );
          }
        }

        // Validate array items
        if (propObj.type === "array" && propObj.items) {
          const itemValidation = validateSchema(propObj.items);
          if (!itemValidation.valid) {
            errors.push(
              `Property "${name}" has invalid array items: ${itemValidation.errors.join(
                ", "
              )}`
            );
          }
        }
      });
    }
  }

  return { valid: errors.length === 0, errors };
}
